<template>
    <div v-if="!isMobile">
        <div class="sorting" style="margin-top: 30px">
            <b-dropdown :id="`sorting${isMorePhotosSection ? '-more-photos': ''}`" variant="link" class="sorting__btn" right>
                <template slot="button-content">
                    <span class="material-icon icon-filter_list"></span>
                    {{ $t('filter') }}
                </template>
                <b-dropdown-item to="" :active="currentSortParam === null"
                                 @click="setActiveSortingItem(null)">{{ $t(`sorting.default`) }}
                </b-dropdown-item>
                <b-dropdown-item to="" v-for="(item, i) in sortParams" :key="i" :active="currentSortParam === item"
                                 @click="setActiveSortingItem(item)">{{ $t(`sorting.${item}`) }}
                </b-dropdown-item>
            </b-dropdown>
            <b-tooltip placement="left" :target="`sorting${isMorePhotosSection ? '-more-photos': ''}`">
                {{ $t('helpers.sort_photos') }}
            </b-tooltip>
        </div>
    </div>
    <div v-else>
        <div class="mobile-common-menu" :class="{'mobile-common-menu--open': mobileSortingMenu}">
            <template v-if="mobileSortingMenu">
                <div class="mobile-common-menu__container js-mobile-menu-container">
                    <div class="mobile-common-menu__container-inner">
                        <div class="mobile-common-menu__content">
                            <ul class="mobile-common-menu__links">
                                <li class="mobile-common-menu__link">
                                    <a href="#" @click.prevent="setActiveSortingItem(null)" :class="{'active': currentSortParam === null}">{{ $t(`sorting.default`) }}</a>
                                </li>
                                <li v-for="(item, i) in sortParams" :key="i" class="mobile-common-menu__link">
                                    <a href="#" @click.prevent="setActiveSortingItem(item)" :class="{'active': currentSortParam === item}">{{ $t(`sorting.${item}`) }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <ul class="mobile-common-menu__actions">
                    <li class="mobile-common-menu__action">
                        <a href="#" class="action-link" @click.prevent="setActiveSortingItem(null)">
                            <span class="material-icon icon-rotate_left"/>
                            <span class="action-link__txt">{{ $t('reset') }}</span>
                        </a>
                    </li>
                </ul>
                <a href="#" @click.prevent="$store.dispatch('SET_MOBILE_SORTING_MENU', false)"
                   class="mobile-common-menu__btn -red">
                    <span class="material-icon icon-clear"/>
                </a>
            </template>
            <div v-else id="sorting" class="sorting" style="margin-top: 20px">
                <div class="sorting__btn">
                    <button type="button" @click.prevent="$store.dispatch('SET_MOBILE_SORTING_MENU', true)" class="btn btn-link">
                        <span class="material-icon icon-filter_list"></span>
                        {{ $t('filter') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .sorting {
        margin-left: auto;

        &__btn {
            display: flex;
            margin-left: 20px;
            color: var(--text-secondary-color);
            font-size: .87rem;
            background-color: var(--bg-secondary-color);
            border-radius: 18px;
            transition: background-color .3s ease;

            &,
            &:hover,
            &:focus {
                text-decoration: none;
            }

            &:hover {
                color: var(--text-color);
                background-color: var(--bg-color);
            }

            .material-icon {
                margin: 1px 5px 0 0;
                font-size: 1rem !important;
            }

            > .btn {
                height: 36px;
                padding: 8px 14px;
                background-color: transparent;

                &,
                &:hover,
                &:focus {
                    color: inherit;
                    text-decoration: none;
                }

                &::after {
                    content: none;
                }
            }

            .dropdown-menu {
                margin: 7px 0;
            }
        }
    }
</style>

<script>
  import sorting from 'src/mixins/sortingComponent';

  export default {
    mixins: [sorting],
  };
</script>
